import { StandardEvents } from '@shopify/events';
const generations = new WeakMap();
document.addEventListener(StandardEvents.productSelect, async event => {
  const target = event.target;
  if (!(target instanceof Element) || target.closest('product-card, quick-add-dialog')) return;
  const scope = target.closest('.shopify-section') || target.closest('main');
  if (!scope || !event.promise) return;
  const generation = (generations.get(scope) || 0) + 1;
  generations.set(scope, generation);
  try {
    const { detail } = await event.promise;
    if (generations.get(scope) !== generation || !detail?.html) return;
    scope.querySelectorAll('[data-tbp-panel]').forEach(panel => {
      const updated = detail.html.querySelector('[data-tbp-panel][data-product-id="' + CSS.escape(panel.dataset.productId) + '"]');
      if (updated) panel.replaceChildren(...Array.from(updated.childNodes, node => node.cloneNode(true)));
    });
    scope.querySelectorAll('[data-tbp-whatsapp]').forEach(button => {
      const updated = detail.html.querySelector('[data-tbp-whatsapp][data-product-id="' + CSS.escape(button.dataset.productId) + '"]');
      if (updated) button.href = updated.href;
    });
  } catch (error) {
    if (error?.name !== 'AbortError') return;
  }
});

document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-tbp-whatsapp]');
  if (!(button instanceof HTMLAnchorElement)) return;
  const form = button.closest('product-form-component')?.querySelector('form');
  if (!(form instanceof HTMLFormElement)) return;
  if (button.href !== button.dataset.teaFormGeneratedHref) button.dataset.teaFormBaseHref = button.href;
  const url = new URL(button.dataset.teaFormBaseHref || button.href);
  const selectedForm = new FormData(form).get('properties[Tea form]');
  if (typeof selectedForm === 'string' && selectedForm) {
    url.searchParams.set('text', (url.searchParams.get('text') || '') + '\n' + button.dataset.teaFormLabel + ': ' + selectedForm);
  }
  button.href = url.href;
  button.dataset.teaFormGeneratedHref = button.href;
});
